type SectionConfig = {
  key: string
  anchor: string
}

export const SECTIONS: SectionConfig[] = [
  { key: 'why us?', anchor: '#_whyus' },
  { key: 'commission', anchor: '#_commission' },
  { key: 'testimonials', anchor: '#_testimonials' },
  { key: 'faq', anchor: '#_faq' },
  { key: 'contacts', anchor: '#_contacts' },
]
